import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.sidebar');
import { OnInit, OnDestroy } from '@angular/core';
import { HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-nav-sidebar',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/component.nav.sidebar/view.scss */
:host {
  display: contents;
}`],
})
export class ComponentNavSidebarComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public category: string = '';
    private routerSub: any;

    public categoryList: any[] = [
        { key: 'fund', title: 'MY 조합', color: 'zinc' },
        { key: 'invest', title: '투자관리', color: 'blue' },
        { key: 'support', title: '지원사업', color: 'emerald' },
        { key: 'tips', title: '팁스', color: 'amber' },
        { key: 'lips', title: '립스', color: 'cyan' },
        { key: 'system', title: '관리시스템', color: 'violet' },
        { key: 'collab', title: '협업툴', color: 'rose' }
    ];

    public async ngOnInit() {
        // Subscribe before authentication/page initialization. The admin page
        // can redirect /admin to its default section while service.init() is
        // pending; subscribing afterwards misses that first NavigationEnd and
        // leaves category empty until the user navigates again.
        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                this.detectCategory(event.urlAfterRedirects || event.url);
                await this.service.render();
            }
        });

        this.detectCategory(this.router.url);
        await this.service.init();
        this.detectCategory(this.router.url);
        await this.service.render();
    }

    ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    private detectCategory(path: string = '') {
        const currentPath = (path || location.pathname).split(/[?#]/)[0];
        const parts = currentPath.split('/');
        if (parts.length >= 2 && parts[1] === 'fund') {
            this.category = 'fund';
        } else if (parts.length >= 3 && parts[1] === 'admin') {
            const cat = parts[2];
            if (['invest', 'support', 'tips', 'lips', 'system', 'collab'].includes(cat)) {
                this.category = cat;
            } else {
                this.category = '';
            }
        } else {
            this.category = '';
        }
    }

    public getCategoryTitle(): string {
        const found = this.categoryList.find(c => c.key === this.category);
        return found ? found.title : '관리자';
    }

    @HostListener('document:click')
    public clickout() {
        this.service.navbar.toggle(true);
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0
    }

    public activeClass(link: string) {
        if (this.isActive(link)) {
            return "flex items-center gap-3 px-3 py-2 rounded-lg bg-zinc-100 text-zinc-900 text-sm font-medium transition-colors";
        }
        return "flex items-center gap-3 px-3 py-2 rounded-lg text-zinc-500 hover:text-zinc-900 hover:bg-zinc-50 text-sm font-normal transition-colors";
    }

    public isSuperAdmin(): boolean {
        return this.service.auth?.session?.membership === 'super_admin';
    }

    public isAdminUser(): boolean {
        return ['admin', 'super_admin'].includes(this.service.auth?.session?.membership);
    }

    public isComplianceOfficer(): boolean {
        const extra = this.service.auth?.session?.extra || {};
        return !!extra.is_compliance_officer;
    }

    public isComplianceOnly(): boolean {
        return !this.isAdminUser() && this.isComplianceOfficer();
    }

    public complianceChecklistLink(): string {
        return location.pathname;
    }

    public hrRecordsLink(): string {
        return this.isSuperAdmin() ? '/admin/system/hr-records' : '/admin/system/my-hr-records';
    }

    public attendanceLink(): string {
        return this.isSuperAdmin() ? '/admin/system/attendance' : '/admin/system/my-attendance';
    }

    public leaveLink(): string {
        return this.isSuperAdmin() ? '/admin/system/leave' : '/admin/system/my-leave';
    }

    public hrRecordsLabel(): string {
        return this.isSuperAdmin() ? '인사기록카드' : '내 인사기록카드';
    }

    public attendanceLabel(): string {
        return this.isSuperAdmin() ? '근태관리' : '내 근태관리';
    }

    public leaveLabel(): string {
        return this.isSuperAdmin() ? '휴가관리' : '내 휴가관리';
    }
}

export default ComponentNavSidebarComponent;